import React from "react";
import DashboardLayout from "../shared/Layouts/DashboardLayout";
import { Route, Routes } from "react-router-dom";
import { useAppSelector } from "../hooks";
import { selectUser } from "../states/slices/authReducer";
import { courtRoutes, individualRoutes, superAdminRoutes } from "../constants";
import { UserType } from "../utils-func/enums";

function MainRoutes() {
  const user = useAppSelector(selectUser);

  return (
    <DashboardLayout>
      <Routes>
        {(user?.type === UserType.INDIVIDUAL ||
          user?.type === UserType.COMPANY) &&
          individualRoutes.map((item) => (
            <Route element={<item.component />} path={item.path} />
          ))}
        {user?.type === UserType.COURT_STAFF &&
          courtRoutes.map((item) => (
            <Route element={<item.component />} path={item.path} />
          ))}
        {user?.type === UserType.ADMIN &&
          superAdminRoutes.map((item) => (
            <Route element={<item.component />} path={item.path} />
          ))}
      </Routes>
    </DashboardLayout>
  );
}

export default MainRoutes;
